import * as React from "react";
import { Outlet, useNavigate } from "react-router";

import { useAppDispatch, useAppSelector, useWorkspace } from "../hooks";
import { LoadingPage } from "../pages/loading";
import {
  IntegrationsStateStatus,
  loadIntegrations,
} from "../store/slices/integrations";
import { WorkspaceStateStatus } from "../store/slices/workspace";

export const WorkspaceGate = () => {
  const dispatch = useAppDispatch();
  const { status } = useAppSelector((s) => s.workspace);
  const integrations = useAppSelector((s) => s.integrations);
  const navigate = useNavigate();
  const workspace = useWorkspace();
  React.useEffect(() => {
    if (status !== WorkspaceStateStatus.LOADED) return;
    if (workspace === undefined) {
      navigate("/workspaces");
      return;
    }
    dispatch(loadIntegrations({ workspace }));
  }, [dispatch, navigate, status, workspace]);
  if (
    workspace !== undefined &&
    integrations.status === IntegrationsStateStatus.LOADED
  ) {
    return <Outlet />;
  }
  return <LoadingPage />;
};
